var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8346 6.46334V7C12.8339 8.25792 12.4266 9.4819 11.6734 10.4894C10.9202 11.4969 9.86155 12.234 8.65526 12.5906C7.44897 12.9473 6.1597 12.9044 4.97974 12.4685C3.79978 12.0326 2.79235 11.2269 2.1077 10.1716C1.42304 9.11636 1.09785 7.86804 1.18061 6.61285C1.26338 5.35767 1.74967 4.16286 2.56697 3.20663C3.38426 2.2504 4.48876 1.58398 5.71575 1.30675C6.94273 1.02953 8.22646 1.15637 9.37547 1.66834",
    stroke: "#39BAFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 2.33337L7 8.17254L5.25 6.42254",
    stroke: "#39BAFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.4f03b64f9e5ee001df9b9104e17b35a6.svg";
export { ForwardRef as ReactComponent };